// Truncate string based on character limit
export function truncateString (string: string, limit: number): string {
  if (string !== undefined && string !== null) {
    if (string.length > limit) {
      return string.substring(0, limit) + '...'
    } else {
      return string
    }
  } else {
    return ''
  }
}

// Capitalize
export function capitalize (str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

// Pluralize
export function pluralize (str: string): string {
  return str + 's'
}

// Filter description banner tags
export function filterDescriptionBanner (description: string): string {
  let parsedDescription = description

  const tags = [ 'banner-success', 'banner-error', 'banner-warning' ]

  for (let i = 0; i < tags.length; i++) {
    if (parsedDescription.includes(tags[i])) {
      const subStr = parseBannerTag(description, tags[i])
      parsedDescription = parsedDescription.replace(subStr, '')
    }
  }

  return parsedDescription
}

function parseBannerTag (str: string, tag: string): string {
  const indexStart = str.indexOf('<' + tag + '>')
  const indexEnd = str.indexOf('</' + tag + '>')
  const subStr = str.slice(indexStart, indexEnd) + '</' + tag + '>'

  return subStr
}
